<div class="container-xxxl">
  <h1>You do not have access to this system.</h1>
  <p>Please reach out to your systems administrator.</p>
</div>
